import useSWR from 'swr'
import type {Iri} from '../../@types/Api'
import type {VisitCollection, VisitItem, VisitPartial} from '../../@types/entity/Visit'
import type {FetchOption} from '../../components/EnhancedTable/types'
import {createCollectionIri} from '../../utils/iri'
import {type FilterOption, filterToQueryString, usePatch, usePost} from '../useApi'
import {useUserHelperGetCurrent} from './useUser'

type CollectionResponse = {
  readonly visits?: VisitCollection
  readonly error?: Error
}

type VisitCollectionFilter = {
  readonly userIri?: Iri
  readonly stared?: boolean
}
const collectionFilterOptions: FilterOption<VisitCollectionFilter> = {
  userIri: 'user',
  stared: {optional: true, param: 'stared'},
}

export const useVisitCollection = (filter: VisitCollectionFilter | undefined, fetchOptions?: FetchOption, enabled = true): CollectionResponse => {
  const querystring = filterToQueryString<VisitCollectionFilter>(collectionFilterOptions, enabled ? filter : undefined, fetchOptions)

  const {data, error} = useSWR(enabled && querystring ? `${createCollectionIri('visits')}?${querystring.toString()}` : null)
  return {
    visits: data,
    error,
  }
}

export const useVisitFilterFromCurrentUser = (): VisitCollectionFilter => {
  const {user} = useUserHelperGetCurrent()

  return {userIri: user?.['@id']}
}

type UpdatePayload = Omit<CreatePayload, 'spot'>

type CreatePayload = {
  spot: Iri

  stared: boolean
}

export function useVisitCreate(forceInvalidation = true): (payload: CreatePayload) => Promise<VisitItem> {
  return usePost<VisitItem>('visits', forceInvalidation)
}

export function useVisitUpdate(): (visit: VisitPartial, payload: UpdatePayload) => Promise<VisitItem> {
  return usePatch<VisitItem>()
}
